import { Heading, Stack, Text, Box, Image, Grid, Flex } from "@chakra-ui/react";
import React from "react";
import { Helmet } from "react-helmet-async";

const AboutScreen = () => {
  return (
    <>
      {/* Helmet */}
      <Helmet>
        <title>
          About Us - Glory Online Cyber Cafe | Your 24/7 Digital Partner
        </title>
        <meta
          name="description"
          content="Learn more about Glory Online Cyber Cafe, founded by Petras Thakur. We provide affordable, accessible 24/7 digital solutions, from graphic design to document assistance, empowering you to succeed online."
        />
        <link rel="canonical" href="https://www.gloryservices.work/about" />
      </Helmet>
      <Box
        bgImage='url("../assets/2.jpg")'
        height={{ base: "350px", md: "450px" }}
        w="full"
        backgroundSize="100% 100%"
        display="flex"
        alignItems="center"
      >
        <Flex px={{ base: "5", md: "10", lg: "20" }} gap={20}>
          <Stack gap={5} color="white">
            <Heading
              size={{ base: "2xl", md: "3xl", lg: "5xl" }}
              fontWeight="semibold"
              w={{ base: "xs", md: "sm", lg: "3xl" }}
            >
              Welcome to Glory Services <br /> Your Digital Partner!{" "}
            </Heading>
            <Text fontSize={{ base: "sm", md: "md", lg: "lg" }}>
              Empowering You with Easy, Affordable, and Accessible Online
              Solutions Anytime, Anywhere!.
            </Text>
          </Stack>
          <Image
            display={{ base: "none", md: "block" }}
            src="../assets/about.svg"
            alt="about"
            h={{ md: "150px", lg: "200px" }}
          />
        </Flex>
      </Box>

      <Box px={{ base: "10", md: "10", lg: "20" }} py={10}>
        {/* About us */}
        <Stack py={10} textAlign="justify">
          <Heading as="h6" size="xs" letterSpacing="4px">
            ABOUT US
          </Heading>
          <Text
            fontSize={{ base: "xl", md: "3xl" }}
            fontWeight="bold"
            lineHeight="1.2"
          >
            Welcome to Glory Online Cyber Cafe!
          </Text>
          <Text>
            At Glory Online Cyber Cafe, our goal is to make your online tasks
            easy and convenient. Whether you need help with creative projects,
            important documents, or everyday online services, we’re here for
            you. Founded by Petras, a skilled freelancer with experience in
            design, writing, video editing, and digital marketing, we’re here to
            support all your digital needs – any time you need it.
          </Text>
        </Stack>
        {/* Our Mission */}
        <Stack textAlign="justify">
          <Text
            fontSize={{ base: "xl", md: "3xl" }}
            fontWeight="bold"
            lineHeight="1.2"
          >
            Our Mission
          </Text>
          <Text>
            Our mission is to make digital services easy to access, affordable,
            and available whenever you need them. We are here to provide the
            tools and support you need to succeed online. From creative design
            to document assistance, Glory Online Cyber Cafe is here to help you
            reach your goals – no matter where you are or what time it is.
          </Text>
        </Stack>
      </Box>

      {/* Message */}
      <Box
        px={{ base: "10", md: "10", lg: "20" }}
        py={10}
        textAlign="justify"
        bgColor="#fceeee"
      >
        <Heading
          as="h6"
          size="xs"
          letterSpacing="4px"
          textTransform="uppercase"
        >
          Words of our Founder
        </Heading>
        <Grid
          templateColumns={{ base: "1fr", md: "3fr 2fr", lg: "4fr 1fr" }}
          gap={{ base: "10", md: "10", lg: "20" }}
          my={5}
        >
          <Stack>
            <Box mb={1}>
              <span style={{ fontSize: "1.5rem" }}>"</span> Hello! I'm Petras,
              the driving force behind this online cyber cafe. Since 2020, I
              have been working as a freelancer, exploring and excelling in
              various fields like graphic design, content writing, music and
              video editing, blogging, and digital marketing. My journey in the
              digital world has been diverse, allowing me to understand and
              cater to a wide range of digital needs.
            </Box>
            <Box mb={1}>
              In 2021, I also began working as a finance analyst in the
              corporate sector, where I further honed my skills in consulting
              and recruitment. This experience has broadened my expertise,
              allowing me to support clients not only with their digital and
              creative needs but also with professional guidance.
            </Box>
            <Box mb={1}>
              My mission is simple: to provide top-notch services that help your
              work shine and assist you in growing digitally. Whether you need
              support with creative projects, marketing strategies, or
              professional consultancy, I’m here to help. Let's work together to
              bring your ideas to life and elevate your digital presence!{" "}
              <span style={{ fontSize: "1.5rem" }}>"</span>
            </Box>
          </Stack>
          <Stack>
            <Image
              src="../assets/founder.png"
              boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;"
              borderRadius="lg"
            />
            <Stack textAlign="center" gap={0} color="black">
              <Text fontWeight={"bold"} fontSize={"xl"}>
                Petras Thakur
              </Text>
              <Text>Founder, Glory Services</Text>
            </Stack>
          </Stack>
        </Grid>
      </Box>
    </>
  );
};

export default AboutScreen;
